'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaderUnits = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _ = require('../');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var getHeaderUnits = exports.getHeaderUnits = function getHeaderUnits(_ref) {
  var units = _ref.units,
    display = _ref.display;
  var _display = (0, _.parseDisplay)(display);
  return R.converge(function (header, label) {
    return R.isEmpty(label) ? null : {
      header: header,
      label: label
    };
  }, [function (units) {
    return (0, _.dimensionValueDisplay)(_display)(units) + ':';
  }, R.pipe(R.propOr([], 'values'), R.map(R.pipe(R.propOr({}, 'value'), (0, _.dimensionValueDisplay)(_display))), R.join(', '))])(units);
};